import { render, staticRenderFns } from "./applicant_grid_item.vue?vue&type=template&id=6e795a43&scoped=true"
import script from "./applicant_grid_item.vue?vue&type=script&lang=ts"
export * from "./applicant_grid_item.vue?vue&type=script&lang=ts"
import style0 from "./applicant_grid_item.vue?vue&type=style&index=0&id=6e795a43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e795a43",
  null
  
)

export default component.exports